import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { useContent } from "@/contexts/ContentContext";
import Footer from "@/components/Footer";
import Navbar from "@/components/Navbar";
import MarkdownText from "@/components/MarkdownText";

export default function PrivacyPage() {
  const { content, loading } = useContent();
  const text = content?.privacy_policy || "";

  return (
    <div className="min-h-screen bg-stone-50" data-testid="privacy-page">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-20 lg:py-28">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-stone-500 hover:text-emerald-700 mb-8" data-testid="privacy-back-link">
          <ArrowLeft size={16} weight="bold" /> Back to home
        </Link>
        {loading ? (
          <div className="h-48 animate-pulse bg-stone-200 rounded-2xl" />
        ) : (
          <article className="prose-content" data-testid="privacy-content">
            <MarkdownText text={text} />
          </article>
        )}
      </main>
      <Footer />
    </div>
  );
}
